import { render, staticRenderFns } from "./AssessTask.vue?vue&type=template&id=63bfc87e&"
import script from "./AssessTask.vue?vue&type=script&lang=js&"
export * from "./AssessTask.vue?vue&type=script&lang=js&"
import style0 from "./AssessTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports